import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { RequestFormService } from '../../service/requestForm/request-form.service';

@Component({
  selector: 'app-custom-date-picker',
  templateUrl: './custom-date-picker.component.html',
  styleUrls: ['./custom-date-picker.component.scss'],
})
export class CustomDatePickerComponent {
  @Input() label!: string;
  @Input() inputId!: string;
  @Input() inputName!: string;
  @Input() minDate: any = null;
  @Input() maxDate: any;
  @Input() form!: FormGroup;
  @Input() controlname!: FormControl | any;
  @Input() formSubmitted!: boolean;
  @Input() errorMessage!: string;
  @Input() readonly?: boolean | any = false;
  @Input() required?: boolean | any = false;
  @Input() placeholder!: string;
  @Output() onInput = new EventEmitter<Event>();
  constructor(private requestFormService: RequestFormService) {}
  get formControl() {
    return this.form.get(this.controlname);
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
